module.exports = __webpack_public_path__ + "assets/b19.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b19.png
// module id = 604
// module chunks = 0